export const environment = {
  production: true,
  baseUrl: 'https://experttabla.ro/calculator/ro',
  api: 'https://experttabla.ro/api',
  ga: 'G-PBH9SHH9NB',
  pixel: '804347100740903',
  gtm: 'GTM-PRDL7VT',
  contact: {
    phone: '0740 101 510',
    phoneRaw: '0740101510',
    phoneInternational: '+40740101510',
    email: 'vanzari@experttabla.ro',
  },
};
